export default "__VITE_ASSET__C1k7HB7d__"